// extracted by mini-css-extract-plugin
export default {"preview":"jDnhJ","landscape":"ACVbc","portrait":"lolGt","content":"_flFR","tooltip":"esVv2","image":"_8cPr"};